<template>
  <div class="layout">
    <div class="header">
      <div class="logo">
        棉花加工企业数据中心管理系统 {{ versions }}
        <!-- <span @click="menu_change">{{ menu_open ? "关" : "开" }}</span> -->
      </div>
      <div class="user">
        <!-- <div class="userImg"><img :src="userImg" /></div> -->
        <div class="userName">
          {{ userName }}
        </div>
        <!-- <div class="change_password">
          <i class="iconfont icon-xiugaimima"></i>
          <span>修改密码</span>
        </div> -->
        <div class="login_out" @click="logoutFn">
          <i class="iconfont icon-tuichu"></i>
          <span>退出</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div :class="['menu', menu_open ? 'open' : 'close']">
        <Menu :isOpen="menu_open"></Menu>
      </div>
      <div class="views">
        <Content />
      </div>
    </div>
  </div>
</template> 

<script>
import Menu from "./menu.vue";
import Content from "./content.vue";
import { logout } from '@/api/login'
import permMixin from '@/mixins/perm'
export default {
  components: { Menu, Content },
  mixins: [permMixin],
  data() {
    return {
      menu_open: true,
      userImg: require("@/assets/image/bgImg/default_user.png"),
    };
  },
  methods: {
    menu_change() {
      this.menu_open = !this.menu_open;
    },
    logoutFn() {
      logout().then(() => {
        this.$store.commit("logout");
      }).catch(err => {
        this.$store.commit("logout");
      })
    },
  },
  computed: {
    userName() {
      return this.$store.state.userStore.userMsg.userName || "游客";
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  height: 60px;
  width: 100%;
  display: flex;
  padding: 0 $layout_margin;
  box-sizing: border-box;
  justify-content: space-between;
  background: url("~@/assets/image/bgImg/header.png") no-repeat center center/cover;
  align-items: center;

  .logo {
    font-size: 23px;
    font-family: 汉仪大黑简-regular, 汉仪大黑简;
    font-weight: 600;
    color: #ffffff;
  }

  .user {
    $h: 30px;
    display: flex;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;

    .iconfont {
      font-size: 12px;
      margin-right: 7px;
    }

    .userImg {
      width: $h;
      height: $h;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .userName {
      height: $h;
      margin-right: 27px;
      display: flex;
      align-items: center;
    }

    .change_password {
      height: $h;
      margin-right: 27px;
      display: flex;
      align-items: center;
    }

    .login_out {
      height: $h;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
}

.content {
  width: 100%;
  flex: 1;
  height: 0;
  display: flex;

  .menu {
    height: 100%;
    transition: width 0.3s;
    background: #fff;
    user-select: none;

    &.open {
      width: 240px;
    }

    &.close {
      width: 60px;
    }
  }

  .views {
    flex: 1;
    width: 0;
    height: 100%;
  }
}
</style>
